import { Inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { take, tap } from 'rxjs/operators';
import { environment } from '../environments/environment'
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import * as CryptoJS from 'crypto-js';

declare var Intercom: any;
declare var require:any;

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  envIsLoading: boolean = false;
  environment: typeof environment = environment
  constructor(
    private location: Location,
    private authService: AuthService,
    private router: Router,
  ) { }

  encryptText(text: string) {
    return CryptoJS.AES.encrypt(text, environment.jwtTokenEncryptionKey).toString();
  }

  decryptText(encryptedText: string) {
    let bytes = CryptoJS.AES.decrypt(encryptedText, environment.jwtTokenEncryptionKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  encryptStorage = {
    setItem: (key: string, value:string) => sessionStorage.setItem(`@securedbysudo:${key}`, this.encryptText(value)),
    getItem: (key:string) => this.decryptText(sessionStorage.getItem(`@securedbysudo:${key}`) || '') || '',
    removeItem: (key:string) => sessionStorage.removeItem(`@securedbysudo:${key}`),
    clear: () => sessionStorage.clear()
  }

  encryptLocalStorage = {
    setItem: (key: string, value:string) => localStorage.setItem(`@securedbysudo:${key}`, this.encryptText(value)),
    getItem: (key:string) => this.decryptText(localStorage.getItem(`@securedbysudo:${key}`) || '') || '',
    removeItem: (key:string) => localStorage.removeItem(`@securedbysudo:${key}`),
    clear: () => localStorage.clear()
  }

  goBack() {
    this.location.back();
  }

  formatDateISO(date: any): string {
    var d = new Date(date);
    return d.toISOString().split("T")[0];
  }

  validateEmailAddress(emailString: string) {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !!emailString && typeof emailString === 'string'
      && emailString.match(emailRegex);
  }

  validateURL(str: string) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  copyText(text: any): boolean {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    return true;
  }

  changePINInputmode() {
    setTimeout(() => {
      let otps: HTMLCollection = document.getElementsByClassName('otp-input');
      for (let i = 0; i < otps.length; i++) {
        document.getElementsByClassName('otp-input')[i].setAttribute("inputmode", "numeric");
      }
    }, 500);
  }


  logoutUser() {
    this.removeLoginData();
    window.location.replace('/signin');
    // this.router.navigate(['/signin'], { replaceUrl: true });
  }

  setToken(jwtToken: string) {
    this.encryptStorage.setItem('token', jwtToken);
  }

  getToken(): string {
    return this.encryptStorage.getItem('token')!;
  }

  removeLoginData() {
    this.encryptStorage.removeItem('token');
  }

  getLastActiveBusiness(): string {
    return this.encryptLocalStorage.getItem('business') ?? '';
  }

  setLastActiveBusiness(businessId: string) {
    this.encryptLocalStorage.setItem('business', businessId);
  }

  getUser(){
    return this.encryptLocalStorage.getItem('userData');
  }

  setUser(userData: any){
    this.encryptLocalStorage.setItem('userData', userData)
  }

  clearEnvironment() {
    localStorage.clear();
  }
}
